import BaseTable from "@/components/base/table/base-table.vue"
import BaseFilter from "@/components/base/filter/base-filter.vue"
import BaseTableColumn from "@/components/base/table-column/base-table-column.vue"
import BaseColumns from "@/components/base/columns/base-columns"
import BaseVisibilityFilterMenu from "@/components/base/visibility-filter-menu"
import BaseDatePicker from "@/components/base/date-picker"
import BaseAlert from "@/components/base/alert"

import {Linker} from "@/directives/linker"
import {ObserveVisibility} from "vue-observe-visibility"

import { initElementPlusIcons } from "@/ui/eleme-ui";


export const initBaseComponents = (app) => {
  app.component(BaseTable.name, BaseTable)
  app.component(BaseFilter.name, BaseFilter)
  app.component(BaseTableColumn.name, BaseTableColumn)
  app.component(BaseColumns.name, BaseColumns)
  app.component(BaseVisibilityFilterMenu.name, BaseVisibilityFilterMenu)
  app.component(BaseDatePicker.name, BaseDatePicker)
  app.component(BaseAlert.name, BaseAlert)
}

export const initDirectives = (app) => {
  app.directive(Linker.name, Linker)
  app.directive("observe-visibility", ObserveVisibility)
}

export const addPlugins = (app) => {
  initElementPlusIcons(app)
  initBaseComponents(app)
  initDirectives(app)
}
